export const searchFieldOptions = [
  { label: "Creator User Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Phone Number", value: "phone_number" }
];

export const infoOptions = [
  {
    label: "Pending Approval",
    color: "#E9A30C",
    apiKey: "pending_approval"
  },
  {
    label: "Activated",
    color: "#3F9142",
    apiKey: "activated"
  },
  {
    label: "Restricted",
    color: "#C62828",
    apiKey: "restricted"
  }
];

export const subscriptionOptions = [
  {
    label: "Paid",
    value: "paid"
  },
  {
    label: "Free",
    value: "free"
  }
];
